export const PATH = {
  DEFAULT: "https://fininsurance.co.th:2022/api/v1/insurance",
  CENTER: "https://www.fininsurance.co.th/api-system/api_center.php",
  INSURE: {
    KUMPAI: "https://www.fininsurance.co.th/api-system/api_center.php",
    CHUBB: "https://www.fininsurance.co.th/api-system/api_center.php",
    INTRA: "https://www.fininsurance.co.th/api-system/api_center.php",
  },
  PRB: {
    INTRA:
      "https://www.fininsurance.co.th/api-system/api_test_soap_intra_front.php",
    AXA: "https://www.fininsurance.co.th/api-system/api_test_rest_axa_front.php",
    AXA_NEW:
      "https://www.fininsurance.co.th/api-system/api_test_rest_axa_front_v3.php",
    AXA_TEST:
      "https://www.fininsurance.co.th/api-system/api_test_rest_axa_front_uat_v3.php",
    AXA_CANCEL:
      "https://www.fininsurance.co.th/api-system/api_axa_cancel_front_v3.php",
    AXA_CANCEL_UAT:
      "https://www.fininsurance.co.th/api-system/api_axa_cancel_front_uat_v3.php",
    KUMPAI: "https://www.fininsurance.co.th/api-system/api_center.php",
    CHUBB: "https://www.fininsurance.co.th/api-system/api_center.php",
    MTI_CANCEL:
      "https://www.fininsurance.co.th/api-system/api_mti_cancel.php",
  },
  TASK: "https://www.fininsurance.co.th/api-system/task-agent-api-save.php",
  TASK_CANCEL:
    "https://www.fininsurance.co.th/api-system/api_save_cancel_vif.php",
  MY_SAVE: "https://www.fininsurance.co.th/api-system/call_api_mysave.php",
};
